<template>
  <div class="article" :class="{ 'app-content': isApp }">
    <AppNavbar
      v-if="isApp"
      :placeholder="true"
      :options="options"
      :zIndex="999"
      title="文章详情"
    >
      <div slot="right">
        <img
          class="share-btn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5b90aa968ca3f06dd306bfbff30c2166.png"
          alt=""
          @click="bindShare"
        />
      </div>
    </AppNavbar>
    <div class="download" v-if="!isApp">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="text1">betterWE星球</div>
        <div class="text2">一站式真人营养师服务平台</div>
      </div>
      <div class="btn">
        <span>打开看看</span>
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>
    <div v-if="info" class="box">
      <div class="content">
        <div class="title">{{ info.base.title }}</div>
        <div class="time"
          >{{ info.detail.total_pv }}阅读 ·
          {{ info.base.create_time | filterTime }}</div
        >
        <div class="user-info" v-if="info.base.user">
          <div class="user-left">
            <img
              class="avatar"
              @click.stop="bindToUserInfo"
              :src="info.base.user.u_img"
              alt=""
            />
            <div class="nickname">{{ info.base.user.u_name }}</div>
            <img
              class="flag"
              v-if="info.base.user.label_data"
              :src="info.base.user.label_data.icon"
              alt=""
            />
          </div>
          <div
            class="focus"
            v-if="isApp && !isSelf"
            :class="{ 'focus-active': info.base.user.is_follow }"
            @click="bindToggleFocus"
          >
            <span
              v-if="!info.base.user.is_follow"
              class="iconfont icon-jiahao"
            ></span>
            <span v-if="!info.base.user.is_follow">关注</span>
            <span v-else>已关注</span>
          </div>
        </div>
        <div
          class="a-html"
          v-if="info.detail.content"
          v-html="info.detail.content"
        >
        </div>
      </div>
      <RecommendComponent
        style="margin-bottom: 8px"
        :data="recommendData"
      ></RecommendComponent>
      <CommentContent :isApp="isApp" :info="info" />
    </div>
    <PageLoading v-else />
    <!-- 分享组件 -->
    <van-overlay :show="showShare" @click="showShare = false" z-index="999">
      <ShareComponent
        v-if="showShare"
        class="share-container"
        @close="bindCloseShare"
        @link="bindClickLink"
        :copyUrl="qrcodeUrl"
        :linkShareIcon="linkShareIcon"
      />
    </van-overlay>
    <div class="download-btn" v-if="!isApp">
      <span>App 内打开</span>
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import ShareComponent from '@/components/app/share'
import RecommendComponent from './components/recommend.vue'
import CommentContent from './components/comment-content.vue'
import PageLoading from './components/loading.vue'
export default {
  components: {
    AppNavbar,
    RecommendComponent,
    CommentContent,
    PageLoading,
    ShareComponent,
    WxOpenLaunchApp
  },
  data() {
    return {
      isApp: false,
      sign: '',
      qrcodeUrl: '',
      showShare: false,
      options: {
        fontSize: '16px'
      },
      commentData: [],
      recommendData: [],
      loading: false,
      finished: false,
      page: 1,
      info: null,
      image:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/api/1681264458147347_wh=961_968.jpg',
      flag: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a683d1b45dc117cd0fdfccf8e813488c.png',
      linkShareIcon: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接'
        }
      ],
      extinfo: ''
    }
  },
  filters: {
    filterTime(str) {
      let res = str.split(' ')[0].replace(/-/g, '.')
      return res
    }
  },
  computed: {
    isSelf() {
      if (this.info) {
        let userInfo = this.$store.state.userInfo
        if (userInfo) {
          let unify_id = userInfo.user && userInfo.user.unify_id
          return this.info.base.user.unify_id == unify_id
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  created() {
    this.isApp = this.$http._isApp()
    this.getParams()
    this.getDetail()
    if (this.isApp) {
      this.getRecommend()
    }
  },
  methods: {
    getParams() {
      if (this.$route.query.sign) {
        this.sign = this.$route.query.sign
      }
      this.tabType = this.$route.query.tab_type || 'weapp_group_unify'
      this.tid = this.$route.query.tid || 0
      let url =
        location.origin +
        location.pathname +
        '?tid=' +
        this.tid +
        '&tab_type=' +
        this.tabType
      this.extinfo = '/web?url=' + encodeURIComponent(url)
    },
    getRecommend() {
      let params = {
        group_unify_id: this.tid
      }
      this.$http
        .getBaseApp('api/v2/appCamp/articleRecommend', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.recommendData = res.data || []
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {})
    },
    bindToggleFocus() {
      let state = +!this.info.base.user.is_follow
      let params = {
        unify_id: this.info.base.user.unify_id,
        flag: state
      }
      this.$http
        .postBaseAppNeedLogin('member/appCamp/optionFollow', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info.base.user.is_follow = state
            this.$betterwe.addUpdateUgcDataEvent({
              id: this.info.base.user.unify_id,
              type: 3,
              isFollow: state
            })
            this.$toast(state ? '关注成功' : '取消关注')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindToUserInfo() {
      if (this.info.base.user.label_data?.jump_router) {
        this.$betterwe.jumpRoute(this.info.base.user.label_data.jump_router)
      }
    },
    getDetail() {
      console.log('获取文章详情')
      let params = {
        tab_type: this.tabType,
        id: this.tid,
        sign: this.$route.query.sign
      }
      this.$http
        .getBaseApp('api/v2/Ugc/getUgcDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (
              res.data &&
              Object.prototype.toString.call(res.data) === '[object Object]'
            ) {
              this.info = res.data
              this.sign = this.getSign()
              this.qrcodeUrl =
                location.origin +
                location.pathname +
                '?tid=' +
                this.info.detail.id +
                '&tab_type=' +
                this.info.detail.tab_type +
                '&sign=' +
                this.sign
            } else {
              this.notData = true
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {})
    },
    //获取签名
    getSign() {
      let key =
        this.info.detail.id +
        '+' +
        this.info.detail.tab_type +
        '+' +
        'betterWe2023'
      key = md5(key)
      return key
    },
    bindShare() {
      this.showShare = true
    },
    bindCloseShare() {
      this.showShare = false
    },
    bindClickLink(index) {
      switch (index) {
        case 0:
          this.shareFriend(0)
          break
        case 1:
          this.shareWechatCicle(0)
          break
      }
      setTimeout(() => {
        this.showShare = false
      }, 1500)
    },
    //分享到微信好友
    shareFriend(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '上betterWE，让你越吃越美，快来看看 >>',
            title: this.info.base.title,
            thumbnail: this.info.detail.cover_image.url // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '上betterWE，让你越吃越美，快来看看 >>',
            title: this.info.base.title,
            thumbnail: this.info.detail.cover_image.url // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信朋友圈
    shareWechatCicle(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '上betterWE，让你越吃越美，快来看看 >>',
            title: this.info.base.title,
            thumbnail: this.info.detail.cover_image.url // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '上betterWE，让你越吃越美，快来看看 >>',
            title: this.info.base.title,
            thumbnail: this.info.detail.cover_image.url // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.article {
  //  user-select: none;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #fff;

  .download {
    position: sticky;
    width: 100%;
    height: 56px;
    background-color: #fff;
    box-shadow: 0 0.5px 0 #ededed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    padding: 0px 15px;
    box-sizing: border-box;

    .logo {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }

    .center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .text1 {
        font-size: 15px;
        line-height: 23px;
      }

      .text2 {
        font-size: 12px;
        line-height: 16px;
        color: #999;
      }
    }

    .btn {
      position: relative;
      width: 72px;
      background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
      height: 26px;
      text-align: center;
      border-radius: 13px;
      line-height: 26px;
      font-size: 13px;
      color: #fff;
    }
  }

  .box {
    background-color: #f7f7f7;
  }

  .content {
    padding: 16px 16px 30px;
    background-color: #fff;
    margin-bottom: 8px;

    .title {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 36px;
      margin-bottom: 8px;
    }

    .time {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 16px;
    }

    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      .user-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 20px;
        display: flex;
        align-items: center;

        .avatar {
          width: 32px;
          height: 32px;
          background: #d8d8d8;
          border-radius: 8px;
          overflow: hidden;
          object-fit: cover;
          margin-right: 8px;
        }

        .nickname {
          max-width: 180px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-right: 4px;
        }

        .flag {
          height: 16px;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .focus {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 24px;
        border-radius: 12px;
        border: 1px solid rgb(98, 54, 255);
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgb(98, 54, 255);
        .iconfont {
          margin-right: 2px;
        }
      }
      .focus-active {
        border: 1px solid rgb(238, 238, 238);
        color: rgb(178, 178, 178);
      }
    }

    .a-html {
      overflow: hidden;
      position: relative;
      z-index: 1;
    }
  }

  .loading {
    width: 100%;
  }
}

.app-content {
  padding-bottom: 60px;
}

.share-btn {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.share-container {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}

.download-btn {
  width: 163px;
  height: 40px;
  position: fixed;
  left: 50%;
  bottom: 68px;
  transform: translate(-50%, 0%);
  border-radius: 20px;
  z-index: 999;
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
}
</style>
